/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';

export type AdrressProps = {
  cep: string;
  complemento: string;
  localidade: string;
  logradouro: string;
  uf: string;
  bairro: string;
};

async function getAddress(cep: string) {
  const { data: address } = await axios.get(
    `https://viacep.com.br/ws/${cep}/json/`,
  );
  return address as AdrressProps;
}

export default getAddress;
